import React from 'react';

const Question = ({ className = '', title = '' }) => {
  return (
    <svg width="17" height="26" viewBox="0 0 17 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <path d="M8.73873 18.07C10.1387 18.07 10.9437 17.405 11.5037 15.76C11.5737 15.515 11.7137 15.235 11.9587 14.85C12.9387 13.415 13.8487 13.065 15.1087 11.735C16.4037 10.37 16.9287 9.075 16.9287 7.36C16.9287 3.125 13.6037 0.149999 8.87873 0.149999C4.36373 0.149999 0.793731 3.02 0.793731 6.66C0.793731 8.515 1.73873 9.53 3.45373 9.53C4.78373 9.53 5.58873 8.9 5.90373 7.64C6.28873 5.855 7.23373 4.945 8.70373 4.945C10.3487 4.945 11.4687 6.03 11.4687 7.64C11.4687 8.83 10.9787 9.495 8.91373 11C8.00373 11.665 7.40873 12.295 6.88373 13.135C6.32373 14.045 6.07873 14.85 6.07873 15.62C6.07873 17.125 7.09373 18.07 8.73873 18.07ZM8.70373 25.35C10.4537 25.35 11.6087 24.16 11.6087 22.41C11.6087 20.695 10.4537 19.47 8.70373 19.47C6.95373 19.47 5.72873 20.695 5.72873 22.41C5.72873 24.16 6.95373 25.35 8.70373 25.35Z" fill="#FCEE21"/>
    </svg>
  )
};

export default Question;
